module.exports = __webpack_public_path__ + "static/media/football.aee19b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/categories/football.png
// module id = 1649
// module chunks = 0